/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Summary_NextInputs */

const en_us2_wrapped_period_summary_next = /** @type {(inputs: Wrapped_Period_Summary_NextInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`The next month has already begun.`);
	return /** @type {LocalizedString} */ (`The next year has already begun.`)
	
};

const pt_br2_wrapped_period_summary_next = /** @type {(inputs: Wrapped_Period_Summary_NextInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`O próximo mês já começou.`);
	return /** @type {LocalizedString} */ (`O próximo ano já começou.`)
	
};

const es_419_wrapped_period_summary_next = /** @type {(inputs: Wrapped_Period_Summary_NextInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`El próximo mes ya empezó.`);
	return /** @type {LocalizedString} */ (`El próximo año ya empezó.`)
	
};

const pt_pt2_wrapped_period_summary_next = /** @type {(inputs: Wrapped_Period_Summary_NextInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`O próximo mês já começou.`);
	return /** @type {LocalizedString} */ (`O próximo ano já começou.`)
	
};

const fr_fr2_wrapped_period_summary_next = /** @type {(inputs: Wrapped_Period_Summary_NextInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Le mois suivant a déjà commencé.`);
	return /** @type {LocalizedString} */ (`L'année suivante a déjà commencé.`)
	
};

const de_de2_wrapped_period_summary_next = /** @type {(inputs: Wrapped_Period_Summary_NextInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Der nächste Monat hat schon begonnen.`);
	return /** @type {LocalizedString} */ (`Das nächste Jahr hat schon begonnen.`)
	
};

const it_it2_wrapped_period_summary_next = /** @type {(inputs: Wrapped_Period_Summary_NextInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Il mese successivo è già iniziato.`);
	return /** @type {LocalizedString} */ (`L'anno successivo è già iniziato.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "The next month has already begun." |
* | * | "The next year has already begun." |
*
* @param {Wrapped_Period_Summary_NextInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_summary_next = /** @type {((inputs: Wrapped_Period_Summary_NextInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Summary_NextInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_summary_next(inputs)
	if (locale === "es-419") return es_419_wrapped_period_summary_next(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_summary_next(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_summary_next(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_summary_next(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_summary_next(inputs)
	return en_us2_wrapped_period_summary_next(inputs)
});
export { wrapped_period_summary_next as "wrapped-period.summary_next" }